export const chatFragment = `
  fragment ChatFragment on Chat {
    id
    companyId
    createdAt

    personId
    person {
      name
      phone
    }

    vehicles {
      id
      unit
    }

    lastMessage {
      id
      createdAt
      
      text
      
      senderType
      senderId

      senderAccount {
        login
      }

      attachments {
        name
        url
      }
    }

    unreadCount

    isPaused
  }
`;

export const chatSubscriptionFragment = `
  fragment ChatFragment on Chat {
    id
    companyId
    createdAt

    lastMessage {
      id
      createdAt
      
      text
      
      senderType
      senderId

      senderAccount {
        login
      }

      attachments {
        name
        url
      }
    }

    unreadCount

    isPaused
  }
`;